import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { connect } from 'react-redux';
import isUuid from 'is-uuid';
import { func, node, shape } from 'prop-types';

import { CurrentCandidateStore } from '../stores/protected/current-candidate-store';
import { AppStore } from '../stores/app-store';
import RecordStateHelperTreatment from '../components/RecordStateHelperTreatment/RecordStateHelperTreatment';
import StoreStateTreatment from '../components/StoreStateTreatment/StoreStateTreatment';
import LoadingTreatment from '../components/LoadingTreatment/LoadingTreatment';
import { LoadingCurtain } from '../components/LoadingCurtain/LoadingCurtain';
import { UserStore } from '../stores/protected/user-store';

const TalentDataProviderComponent = ({
  user,
  candidateState,
  initTalentAppState,
  children,
}) => {
  const { candidateId } = useParams();

  useEffect(() => {
    initTalentAppState(
      user.roles.some(r => r.startsWith('Envoy')) &&
        isUuid.anyNonNil(candidateId)
        ? candidateId
        : user.candidateId,
      user
    );
  }, [candidateId]);

  return (
    <RecordStateHelperTreatment
      recordState={candidateState}
      initialLoader={<LoadingTreatment />}
      refetchLoader={<LoadingCurtain isFullscreen />}
    >
      <StoreStateTreatment storeState={[]} renderLoadedView={() => children} />
    </RecordStateHelperTreatment>
  );
};

TalentDataProviderComponent.propTypes = {
  candidateState: shape({}).isRequired,
  children: node,
  initTalentAppState: func.isRequired,
  user: UserStore.getDataShape().isRequired,
};

TalentDataProviderComponent.defaultProps = {
  children: null,
};

export const TalentDataProvider = connect(
  state => ({
    user: UserStore.selectData(state),
    candidateState: CurrentCandidateStore.selectCandidateState(state),
  }),
  {
    initTalentAppState: AppStore.initTalentAppState,
  }
)(TalentDataProviderComponent);
